import { jsxs as i, jsx as n } from "react/jsx-runtime";
const l = (e) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ n(
        "g",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          clipPath: "url(#pinned_svg__a)",
          children: /* @__PURE__ */ n("path", { d: "M9 4v6l-2 4v2h10v-2l-2-4V4M12 16v5M8 4h8" })
        }
      ),
      /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", { id: "pinned_svg__a", children: /* @__PURE__ */ n("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  l as default
};
